module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('errors.' + _vm.error.code)) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.success == false) ? _c('form', {
    staticClass: "password-reset-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('ui.auth.password_reset_title')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.password_reset')))]), _vm._v(" "), _c('field', {
    attrs: {
      "label": " ",
      "name": "token",
      "type": "hidden"
    },
    model: {
      value: (_vm.token),
      callback: function($$v) {
        _vm.token = $$v
      },
      expression: "token"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "placeholder": _vm.$t('ui.auth.password'),
      "name": "password",
      "type": "password",
      "label": "ui.auth.password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "placeholder": _vm.$t('ui.auth.password_confirmation'),
      "name": "password_confirmation",
      "type": "password",
      "label": "ui.auth.password_confirmation"
    },
    model: {
      value: (_vm.password_confirmation),
      callback: function($$v) {
        _vm.password_confirmation = $$v
      },
      expression: "password_confirmation"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-login",
    attrs: {
      "type": "submit",
      "data-action": "user.password_reset"
    },
    domProps: {
      "value": _vm.$t('ui.auth.confirm')
    }
  })])], 1) : _c('div', {
    staticClass: "password-reset-confirm"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('ui.auth.password_reset_title_confirm')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.password_reset_confirm')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/success-password.svg")
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t('ui.auth.return_to_login')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3845a35e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/PasswordReset.vue
// module id = 1870
// module chunks = 0